export function generateHitId(): string {
  return Date.now().toString(36) + '-' + Math.floor(1e10 + 9e10 * Math.random()).toString(36)
}
